import { AgGridModule } from "@bfx/ag-grid-angular";
import { AutoCompleteModule } from "@bfx/primeng/autocomplete";
import { ButtonModule } from "@bfx/primeng/button";
import { CheckboxModule } from "@bfx/primeng/checkbox";
import { CommonModule } from "@angular/common";
import { DialogModule } from "@bfx/primeng/dialog";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule } from "@angular/forms";
import { NgModule } from "@angular/core";
import { OverlayPanelModule } from "@bfx/primeng/overlaypanel";
import { TranslateModule } from "@ngx-translate/core";

import { BfxSharedModule } from "../bfx-shared/bfx-shared.module";
import { BfxBlotterFilterModule } from "../bfx-blotter-filter/bfx-blotter-filter.module";
import { BfxBaseBlotterColumnSelectorService } from "../bfx-base-blotter/bfx-base-blotter-columnselector.service";
import { BfxVwapModule } from "../bfx-vwap/bfx-vwap.module";
import { BfxMenusModule } from "../bfx-menus/bfx-menus.module";
import { BfxOrderLadderFilteringService } from "./services/bfx-ladder-orders-filter.service";
import { BfxLadderOrders } from "./bfx-ladder-orders";
import { BfxBlotterOrdersActionSubjectModule } from "../bfx-blotter-orders/bfx-blotter-orders-action-subject.module";
import { LadderPairRenderer } from "./ladder-pair-renderer";
import { BfxLadderOrdersContextMenu } from "./bfx-ladder-orders-contextmenu";
import { BfxLadderOrdersContextMenuService } from "./bfx-ladder-orders-contextmenu.service";
import { BfxLadderOrdersService } from "./services/bfx-ladder-orders.service";
import { BaseComponentsModule } from "shared/base-components/base-components.module";
import { BfxElementsLibraryModule } from "app/bfx-element-library/bfx-elements-library.module";

@NgModule({
  declarations: [BfxLadderOrdersContextMenu, BfxLadderOrders, LadderPairRenderer],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    FlexLayoutModule,
    AutoCompleteModule,
    CheckboxModule,
    DialogModule,
    ButtonModule,
    OverlayPanelModule,
    AgGridModule.withComponents([]),
    BfxVwapModule,
    BfxSharedModule,
    BfxBlotterFilterModule,
    BfxMenusModule,
    BaseComponentsModule,
    BfxBlotterOrdersActionSubjectModule,
    BfxElementsLibraryModule,
  ],
  exports: [BfxLadderOrders],
  providers: [
    BfxLadderOrdersContextMenuService,
    BfxOrderLadderFilteringService,
    BfxBaseBlotterColumnSelectorService,
    BfxLadderOrdersService,
  ],
  bootstrap: [BfxLadderOrders],
})
export class BfxLadderOrdersModule {}
